// frontend/src/pages/dashboard/CalculatorPage.js
import React from 'react';
import PriceCalculator from '../../components/calculator/PriceCalculator';

const CalculatorPage = () => {
  return (
    <PriceCalculator />
  );
};

export default CalculatorPage;